// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper_3lMa7"};